import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { SpaceTabDocumentType } from 'api/space/space-tab';
import { setupSpaceTabsOnSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import { embedDocumentTemplateAction } from '../actions';
import { DocumentTemplatesAPI } from '../api';
function* embedDocumentTemplateSaga(action) {
    const { payload: { spaceId, url, spaceTabTitle, handleAlways, handleFailure, handleSuccess } } = action;
    try {
        const res = yield DocumentTemplatesAPI.embed(url);
        const spaceTabId = floatUid();
        let spaceTab = {
            spaceTabId,
            spaceTabType: SpaceTabDocumentType.EmbedableDocument,
            url,
            spaceTabTitle: spaceTabTitle !== null && spaceTabTitle !== void 0 ? spaceTabTitle : url
        };
        if (res.error && res.status === 403) {
            spaceTab = {
                ...spaceTab,
                url,
                spaceTabTitle: spaceTabTitle !== null && spaceTabTitle !== void 0 ? spaceTabTitle : url
            };
        } else {
            var _res_meta;
            spaceTab = {
                ...spaceTab,
                url: res.url,
                spaceTabTitle: spaceTabTitle !== null && spaceTabTitle !== void 0 ? spaceTabTitle : (_res_meta = res.meta) === null || _res_meta === void 0 ? void 0 : _res_meta.title,
                metaData: res
            };
        }
        yield put(setupSpaceTabsOnSpaces({
            spaceTab,
            spaceId
        }));
        if (handleSuccess) {
            handleSuccess(spaceTabId);
        }
    } catch (error) {
        logger.log(' an error embedding a link', {
            error
        });
        message.error('There was an error embedding a link');
        if (handleFailure) {
            handleFailure();
        }
    }
    if (handleAlways) {
        handleAlways();
    }
}
export function* watchEmbedDocumentTemplateSaga() {
    yield takeLatest(embedDocumentTemplateAction.type, embedDocumentTemplateSaga);
}
